/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_MAINTENANCE,
  FETCH_MAINTENANCE_SUCCESS,
  FETCH_MAINTENANCE_FAILURE,
  POLL_MAINTENANCE_START,
  POLL_MAINTENANCE_STOP,
  FETCH_SCHEDULE_DEVICES,
  FETCH_SCHEDULE_DEVICES_SUCCESS,
  FETCH_SCHEDULE_DEVICES_FAILURE,
  FETCH_GROUP_DEVICES,
  FETCH_GROUP_DEVICES_SUCCESS,
  FETCH_GROUP_DEVICES_FAILURE,
  FETCH_TIMEZONES_SUCCESS,
  FETCH_TIMEZONES_FAILURE,
  FETCH_CS_MAINTENANCE_LIST,
  FETCH_CS_MAINTENANCE_LIST_SUCCESS,
  FETCH_CS_MAINTENANCE_LIST_FAILURE
} from './actionTypes'
import { Maintenance as maintenanceApi } from './maintenance'
import { TreeView as treeViewApi } from '../treeView/treeView'


export function getMaintenance() {
  return {
    type: FETCH_MAINTENANCE,
  }
}

export function fetchMaintenanceSuccess(json) {
  return {
    type: FETCH_MAINTENANCE_SUCCESS,
    maintenance: json
  }
}

export function fetchMaintenanceFailure(error) {
  return {
    type: FETCH_MAINTENANCE_FAILURE,
    errorMessage: error.message
  }
}

export function pollMaintenanceStart() {
  return {
    type:POLL_MAINTENANCE_START
  }
}

export function pollMaintenanceStop() {
  return {
    type:POLL_MAINTENANCE_STOP
  }
}

export function fetchScheduleDevices(){
  return{
    type:FETCH_SCHEDULE_DEVICES
  }
}

export function getDevicesBySchedule(scheduleId){
  return dispatch => {
    dispatch(fetchScheduleDevices())
    return maintenanceApi.getDevicesFromSchedule(scheduleId)
      .then(response =>  dispatch(fetchScheduleDevicesSuccess(response.data)))
      .catch(function(error) {
        dispatch(fetchScheduleDevicesFailure(error))
      })
  }
}

export function fetchScheduleDevicesSuccess(json) {
  return {
    type: FETCH_SCHEDULE_DEVICES_SUCCESS,
    devices: json
  }
}

export function fetchScheduleDevicesFailure(error) {
  return {
    type: FETCH_SCHEDULE_DEVICES_FAILURE,
    errorMessage: error.message
  }
}

export function fetchGroupDevices(){
  return{
    type:FETCH_GROUP_DEVICES
  }
}

export function getDevicesByGroup(groupId){
  return dispatch => {
    dispatch(fetchGroupDevices())
    return treeViewApi.getDeviceData(groupId)
      .then(response =>  dispatch(fetchGroupDevicesSuccess(response.data)))
      .catch(function(error) {
        dispatch(fetchGroupDevicesFailure(error))
      })
  }
}
export function fetchSchedulesForDevice(){
  return{
    type:FETCH_CS_MAINTENANCE_LIST
  }
}
export function getScheduleseByDevice(csId){
  return dispatch => {
    dispatch(fetchSchedulesForDevice())
    return maintenanceApi.getScheduleForDevices(csId)
      .then(response =>  dispatch(fetchGroupDevicesSuccess(response.data)))
      .catch(function(error) {
        dispatch(fetchGroupDevicesFailure(error))
      })
  }
}

export function fetchDevicesSchedulesSuccess(json) {
  return {
    type: FETCH_CS_MAINTENANCE_LIST_SUCCESS,
    devices: json
  }
}

export function fetchDevicesSchedulesFailure(error) {
  return {
    type: FETCH_CS_MAINTENANCE_LIST_FAILURE,
    errorMessage: error.message
  }
}

export function fetchGroupDevicesSuccess(json) {
  return {
    type: FETCH_GROUP_DEVICES_SUCCESS,
    devices: json
  }
}

export function fetchGroupDevicesFailure(error) {
  return {
    type: FETCH_GROUP_DEVICES_FAILURE,
    errorMessage: error.message
  }
}

export function fetchTimeZoneSuccess(json) {
  return {
    type: FETCH_TIMEZONES_SUCCESS,
    timezones: json
  }
}

export function fetchTimeZoneFailure(error) {
  return {
    type: FETCH_TIMEZONES_FAILURE,
    errorMessage: error.message
  }
}
export function getTimeZones(){
  return dispatch => {
    dispatch(fetchScheduleDevices())
    return maintenanceApi.getTimeZones()
      .then(response =>  dispatch(fetchTimeZoneSuccess(response.data)))
      .catch(function(error) {
        dispatch(fetchTimeZoneFailure(error))
      })
  }
}
